import styled from 'styled-components';

/**
 * 탭2(이력) 의 최상단 컨테이너. ExecuteTabPanel 의 StyledContainer 와 동일한
 * 패딩/세로 간격 톤을 유지해 두 탭이 시각적으로 일관되게 보이도록 한다.
 */
export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px;
`;
